import { get,post } from "@insite/client-framework/Services/ApiService";

import { CreditcardPopupStatusUpdateParameter, CreditCardStatusResponseModel,GetCreditCardPopupStatusParameter } from "@NA/Widgets/CCTokenization/ADICCTokenizationModel";

const creditCardPopURL = "api/v2/creditcardpopup";
const creditCardStatusURL = "api/v2/creditcardpopupdetails";

export  function getCreditCardPopupStatus(parameter: GetCreditCardPopupStatusParameter) {
    return get<CreditCardStatusResponseModel>(creditCardPopURL, parameter);
}


export  function updateCreditCardStatus(requestObject: CreditcardPopupStatusUpdateParameter) {
    return post<CreditcardPopupStatusUpdateParameter>(creditCardStatusURL, requestObject);
}
